import React, { useRef, useEffect } from 'react';
import IframeResizer from 'iframe-resizer-react';
import { Sundhedplus, Denti } from '../../config';
import { cprNoFormat } from 'constants/utils';

interface TermsConditionsProps {
  type: string;
  brand: string;
  clientName: string;
  clientAddress: string;
  clientZip: number;
  clientCity: string;
  loanNumber: string;
  loanAmount: number;
  setupFee: number;
  duration: number;
  interestRate: number;
  apr: string;
  totalCosts: number;
  totalRepayment: number;
  monthlyInstallment: number;
  cpr: string;
  creditFacilityNumber: string;
  loanOwnerNameExtended: string;
  loanOwnerName: string;
  firstPaymentDate: string;
  lastPaymentDate: string;
}

const TermsConditions: React.FC<TermsConditionsProps> = ({
  type,
  brand,
  clientName,
  clientAddress,
  clientZip,
  clientCity,
  loanNumber,
  loanAmount,
  setupFee,
  duration,
  interestRate,
  apr,
  totalCosts,
  totalRepayment,
  monthlyInstallment,
  cpr,
  creditFacilityNumber,
  loanOwnerNameExtended,
  loanOwnerName,
  firstPaymentDate,
  lastPaymentDate,
}) => {
  const iframeRef = useRef(null);
  const formData = {
    type: type ?? '',
    brand: brand ?? 'Sundhed+',
    clientName: clientName ?? '',
    clientAddress: clientAddress ?? '',
    clientZip: clientZip ?? '',
    clientCity: clientCity ?? '',
    loanNumber: loanNumber ?? '',
    loanAmount: loanAmount ?? 0,
    setupFee: setupFee ?? 0,
    duration: duration ?? 0,
    interestRate: interestRate ?? 0,
    apr: apr ?? 0,
    totalCosts: totalCosts ?? 0,
    totalRepayment: totalRepayment ?? 0,
    monthlyInstallment: monthlyInstallment ?? 0,
    cpr: cprNoFormat(cpr) ?? '',
    creditFacilityNumber: creditFacilityNumber ?? '',
    loanOwnerNameExtended: loanOwnerNameExtended ?? '',
    loanOwnerName: loanOwnerName ?? '',
    firstPaymentDate: firstPaymentDate ?? '',
    lastPaymentDate: lastPaymentDate ?? '',
  };

  useEffect(() => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = brand === 'Denti' ? Denti.loanAcceptanceTermsUrl : Sundhedplus.loanAcceptanceTermsUrl;
    form.target = 'resultIframe';

    // Convert JSON data into hidden input fields
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = String(value);
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }, []);

  return (
    <div className='terms-conditions acceptance'>
      <IframeResizer
        title='denti-terms'
        checkOrigin={false}
        name='resultIframe'
        ref={iframeRef}
        heightCalculationMethod='lowestElement'
        style={{
          width: '1px',
          minWidth: '100%',
          border: 0,
          minHeight: '4200px',
        }}
      />
    </div>
  );
};

export default TermsConditions;
